<template>
  <span
    class="info-underline"
    @mouseenter="show = true"
    @mouseleave="show = false"
    style="cursor: pointer; position: relative"
  >
    <strong class="fw-600">{{ formattedAmount }}</strong>
    <span v-if="show" class="popover-table">
      <strong>Gemiddelde kosten per maatregel</strong>
      <table style="width: 100%; margin-top: 0.5em">
        <thead>
          <tr>
            <th style="text-align: left">Maatregel</th>
            <th style="text-align: right">Gemiddelde kosten</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Spouwmuurisolatie</td>
            <td style="text-align: right">€ 2.500</td>
          </tr>
          <tr>
            <td>Vloerisolatie</td>
            <td style="text-align: right">€ 3.000</td>
          </tr>
          <tr>
            <td>Dakisolatie</td>
            <td style="text-align: right">€ 8.000</td>
          </tr>
          <tr>
            <td>Vervangen glas door hr++-glas</td>
            <td style="text-align: right">€ 4.500</td>
          </tr>
        </tbody>
      </table>
    </span>
  </span>
</template>

<script>
export default {
  name: "InfoAveragePriceAmount",
  props: {
    amount: {
      type: [Number, String],
      default: 10000
    }
  },
  data() {
    return { show: false };
  },
  computed: {
    formattedAmount() {
      // Show as €xx.xxx
      let amt = typeof this.amount === 'string' ? parseFloat(this.amount.toString().replace(/[^\d]/g, '')) : this.amount;
      if (isNaN(amt)) amt = 10000;
      return '€' + amt.toLocaleString('nl-NL', { minimumFractionDigits: 0 });
    }
  }
};
</script>

<style>
.info-underline {
  border-bottom: 1px dotted green;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.2s;
}
.info-underline:hover {
  border-bottom: 1px solid green;
}
.popover-table {
  position: absolute;
  left: 0;
  top: 1.8em;
  z-index: 10;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 1em;
  min-width: 270px;
  max-width: 350px;
  font-size: 0.95em;
  color: #222;
}
.popover-table table {
  border-collapse: collapse;
  width: 100%;
}
.popover-table th,
.popover-table td {
  padding: 0.2em 0.4em;
}
.popover-table th {
  font-weight: 600;
  border-bottom: 1px solid #eee;
}
</style>
